module.exports = __webpack_public_path__ + "static/img/step5.8e05597.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/guide/step5.png
// module id = 4eER
// module chunks = 1